
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCompaniesCount }}</span>
          <span class="stats-card-label">Total Companies</span>
          <span class="stats-card-sublabel">All companies</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-building"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeCompaniesCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveCompaniesCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredCompanies"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} companies"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable company-management-table no-column-lines">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Name
            <p-sortIcon field="name" />
          </th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-company>
        <tr [class.row-inactive]="company.isActive === false">
          <td class="td-truncate" [pTooltip]="company.name || ''">{{ company.name }}</td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="company.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="company.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleActiveStatus(company)"
                size="small"
                [pTooltip]="company.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="showEditDialog(company)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="2" class="table-empty-cell">
            <div class="empty-state">
              <i class="pi pi-inbox empty-icon"></i>
              <p class="empty-message">No companies found.</p>
              <p class="empty-description">Try adjusting filters or add a new company.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Company' : 'Edit Company'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedCompany.name.trim()">
          <label for="name">Name <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedCompany.name"
            placeholder="Enter company name" (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedCompany.name.trim()">Name is required</small>
        </div>
      </div>
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedCompany.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedCompany.isActive ? 'success' : 'secondary'" [outlined]="!selectedCompany.isActive"
            (onClick)="selectedCompany.isActive = !selectedCompany.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetCompanyForm()"
        [text]="true" severity="secondary" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()"
        severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveCompany()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
